import { Injectable } from '@angular/core';
import { ApiService } from "./api.service";
import { HttpService } from "../http/http.service";

@Injectable()
export class TrackingsService extends ApiService {
    constructor(protected http: HttpService) {
        super(http);
        this.url = 'api/trackings/'
    }

}



// WEBPACK FOOTER //
// /mnt/volume_sfo2_01/www/html/planet-dev/src/app/shared/services/api/trackings.service.ts